{
  "sectionHeader": "Estatística de tempo de abandono",
  "sectionPara": "Você também pode ajustar especificamente os limites de duração de abandono, que são usados pelas sete variantes de estatísticas abandonadas de entrada do estilo \"Abandonados < = Xs\".",
  "target1Label": "Alvo 1:",
  "target1Placeholder": "60",
  "target2Label": "Alvo 2:",
  "target2Placeholder": "90",
  "target3Label": "Alvo 3:",
  "target3Placeholder": "120",
  "target4Label": "Meta 4:",
  "target4Placeholder": "150",
  "target5Label": "Meta 5:",
  "target5Placeholder": "180",
  "target6Label": "Meta 6:",
  "target6Placeholder": "300",
  "targetUnits": "s",
  "resetAnswerTargetsButtonLabel": "Redefinir intervalos abandonados",
  "resetAnswerTargetsPrompt": "Tem certeza de que deseja redefinir todas as 6 configurações de limites abandonados de entrada para seus valores padrão?",
  "resetAnswerTargetsConfirm": "confirme",
  "resetAnswerTargetsCancel": "Cancelar",
  "NAME": "AbandonedTimeStatisticLanguage"
}